import "./Entity.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
  TableProps,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DeleteOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import Search from "antd/es/input/Search";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import {
  EntitiesMessages,
  Entity as EntityData,
  EntityRaw,
  PageSetting,
  Query,
  SortMode,
} from "../../..";
import { getMeEntities } from "../../../../controllers/store/actions/entities/get-entities-action";
import NewEntityModal from "../../../components/Forms/Modal/Entities/NewEntity";
import UpdateEntityModal from "../../../components/Forms/Modal/Entities/UpdateEntity";
import { remove } from "../../../../controllers/store/actions/entities/delete-entities-action";
import { findById } from "../../../../controllers/store/actions/entities/update-entity-actions";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;

const query: Query = { filter: {} };

const Entity: React.FC = () => {
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  const entityState = useSelector((state: any) => state.entities);
  const updatedEntitiesState = useSelector(
    (state: any) => state.updatedEntities
  );
  const deletedEntitiesState = useSelector(
    (state: any) => state.deletedEntities
  );
  const createdEntitiesState = useSelector(
    (state: any) => state.createdEntities
  );

  const columns: TableProps<EntityRaw>["columns"] = [
    {
      title: "Razón Social",
      dataIndex: "social_reason",
      key: "social_reason",
      render: (text) => text,
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "NIT",
      dataIndex: "nit",
      key: "nit",
    },
    {
      title: "Ciudad",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Departamento",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "Reconocido Min. Ciencia",
      dataIndex: "recognized_min",
      key: "recognized_min",
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Fecha de creación",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Fecha de modificación",
      dataIndex: "updated_at",
      key: "updated_at",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: EntityRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={async () => {
              if (record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: EntitiesMessages.Title,
                content: EntitiesMessages.EntitiesConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(getMeEntities(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreatedEntityMessage = () => {
    api["success"]({
      message: EntitiesMessages.Title,
      description: EntitiesMessages.EntitiesCreated,
    });
  };

  const showDeletedEntityMessage = () => {
    api["success"]({
      message: EntitiesMessages.Title,
      description: EntitiesMessages.EntitiesDeleteSuccessMessage,
    });
  };

  const showUpdatedEntityMessage = () => {
    api["success"]({
      message: EntitiesMessages.Title,
      description: EntitiesMessages.EntitiesUpdateSuccessMessage,
    });
  };

  useEffect(() => {
    dispatch(getMeEntities(page, pageSize, query));
    setInitialDataLoaded(true);
  }, [pageSize]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    console.log("setSearchTerm", value);
    if (value) {
      query.search = value;
    } else {
      delete query.search;
    }
    dispatch(getMeEntities(1, pageSize, query));
  };

  const renderContent = () => {
    return (
      <>
        <h1 className="heading-content-title">Empresas</h1>
        <br />
        {/* Campo de búsqueda */}
        <Row gutter={[8, 8]} style={{ width: "100%", marginBottom: 20 }}>
          <Col xs={24} sm={12} md={8} lg={12}>
            <Flex vertical={true} align={"flex-start"}>
              <Search
                allowClear
                placeholder="Buscar"
                onPressEnter={($event: any) => {
                  if (!$event.target.value) {
                    delete query.search;
                  } else {
                    query.search = `${$event.target.value}`;
                    query.meta = `filter_count`;
                    query.sort = [{ field: "created_at", mode: SortMode.DES }];
                  }
                  dispatch(getMeEntities(1, pageSize, query));
                }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onSearch={handleSearch}
                enterButton
              />
            </Flex>
          </Col>
          <Col xs={24} sm={12} md={8} lg={12}>
            <Flex vertical={true} align={"flex-end"}>
              <Button
                type="primary"
                onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                size="middle"
                icon={<PlusOutlined />}
              >
                Agregar empresa
              </Button>
            </Flex>
          </Col>
        </Row>

        {/* Loader o contenido */}
        {entityState.isLoading ? (
          <Skeleton loading={true} active className="full-width" />
        ) : (
          <Table
            scroll={{ x: 2500 }}
            sticky={{ offsetHeader: 0 }}
            pagination={{
              locale: {
                jump_to: "Ir a",
                items_per_page: "Items por pagina",
              },
              total:
                entityState.meta?.total_count || entityState.meta?.filter_count,
              current: page,
              pageSize: PageSetting.limit,
              onChange: (page) => {
                dispatch(getMeEntities(page, pageSize, query));
                setPage(page);
              },
              onShowSizeChange: (pageSize) => {
                dispatch(getMeEntities(page, pageSize, query));
                setPageSize(pageSize);
              },
            }}
            locale={{
              emptyText: searchTerm
                ? "No se encontraron resultados"
                : "No tienes empresas aún",
            }}
            columns={columns}
            dataSource={entityState.list}
          />
        )}
      </>
    );
  };

  return (
    <Layout className="entities-layout">
      {contextHolder}
      {createdEntitiesState.createdEntities && showCreatedEntityMessage()}
      {deletedEntitiesState.removedEntities && showDeletedEntityMessage()}
      {updatedEntitiesState.updatedEntities && showUpdatedEntityMessage()}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="entities-content">
        <Card className="entities-card">
          <NewEntityModal
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(getMeEntities(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateEntityModal
            entity={updatedEntitiesState.entity}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(getMeEntities(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />
          {renderContent()}
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Entity;
